<script lang="ts" setup>
import FixedRouterView from "@/components/fix/FixedRouterView.vue";
</script>
<template>
  <fixed-router-view v-slot="{ Component }">
    <!-- <KeepAlive :include="['MateEdit']"> -->
    <component :is="Component" />
    <!-- </KeepAlive> -->
  </fixed-router-view>
</template>
